import * as React from 'react';
import * as uuid from 'uuid';
import { FormControlProps } from '../interfaces/FormControlProps';

const uuidV4 = uuid.v4;

/**
 * A component for rendering a button. Can be used to dynamically replace the default submit button.
 * 
 * Current usages:
 * - jaaropgave mijn-fnv 
 * - afsprakenplanner regiokantoor zoeken icm postcode
 */
export class Button extends React.Component<FormControlProps> {
  constructor(props: FormControlProps) {
    super(props);
  }

  private triggerSubmit() {
    this.props.formController.submitToContainer(this.props.formikBag.values, true , true);
  }

  private triggerFormChange() {
    this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, uuid);
    if (this.props.formFieldDefinition.isDependentField) {                    
      const uuid = uuidV4();
      this.props.formController.setState({[this.props.formFieldDefinition.name]: uuid});
    }
  }

  render() {
    const { 
      buttonMode,
      label,
      icon,
      cssClass
    } = this.props.formFieldDefinition;
    const { isSubmitting } = this.props;
    const onButtonClick = (event) => {
      event.preventDefault();
      if (!isSubmitting) {
        if (buttonMode === 'post') {
          this.triggerSubmit();
          return false;
        } else {
          this.triggerFormChange();
        }
      }
      return false;
    };

    const hasIcon = icon && icon !== 'no-icon';
    const btnClassName = (isSubmitting ? 'btn-disabled ' : '')  + cssClass;

    return (
      <div className={buttonMode == "post" ? "d-flex" : ""}>
        <button
            onClick={onButtonClick}
            disabled={isSubmitting}
            className={"button-form-control btn " + btnClassName}
        >
          {hasIcon && (
            <span className={"icon icon-" + icon}></span>
          )}
          {label}
        </button>
        {isSubmitting && buttonMode == "post" && (
            <span className="ml-2 spinner-border"></span>
        )}  
      </div>
    );
  }
}
